import React, { useState } from 'react';
import PartnersSectionHeading from '../components/PartnersSectionHeading';
import { usePartnersStrings } from '../usePartnersStrings';

const PartnersFaq: React.FC = () => {
  const s = usePartnersStrings();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className="container-chisme py-10 lg:py-16">
      <PartnersSectionHeading
        title={
          <>
            <span className="block">{s.faq.titleLine1}</span>
            <span className="block italic text-chisme-primary">{s.faq.titleLine2}</span>
          </>
        }
        subtitle={s.faq.subtitle}
      />

      <div className="mx-auto mt-10 max-w-3xl space-y-3">
        {s.faq.items.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <div
              key={item.question}
              className="overflow-hidden rounded-[24px] border border-[rgba(74,33,71,0.1)] bg-white"
            >
              <button
                type="button"
                onClick={() => toggle(index)}
                className="flex w-full items-center justify-between gap-4 p-5 text-left sm:p-6"
                aria-expanded={isOpen}
              >
                <span className="font-jakarta text-base font-semibold text-[#2a0f2a] sm:text-lg">
                  {item.question}
                </span>
                <span
                  className="flex size-8 shrink-0 items-center justify-center rounded-full bg-[#F2E8F0] text-chisme-primary"
                  aria-hidden
                >
                  <svg
                    viewBox="0 0 16 16"
                    className={`size-3.5 transition-transform duration-200 ease-in-out ${
                      isOpen ? 'rotate-45' : ''
                    }`}
                  >
                    <path
                      d="M8 3.25v9.5M3.25 8h9.5"
                      stroke="currentColor"
                      strokeWidth="1.75"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
              </button>
              <div
                className={`grid transition-all duration-200 ease-in-out ${
                  isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                }`}
              >
                <div className="overflow-hidden">
                  <p className="px-5 pb-5 font-jakarta text-[15px] leading-relaxed text-[#5a3158] sm:px-6 sm:pb-6">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default PartnersFaq;
